{
  "countryOrRegion": "ประเทศ/ภูมิภาค",
  "defaultCountry": "ไทย",
  "familyName": "นามสกุล",
  "givenName": "ชื่อ",
  "identityNumber": "หมายเลขบัตรประจำตัว",
  "identityPhotos": "รูปบัตรประจำตัว",
  "identityPhotoFront": "ด้านหน้าบัตรประจำตัว",
  "identityPhotoBack": "ด้านหลังบัตรประจำตัว",
  "identityPhotoHint": "โปรดให้ขอบบัตรอยู่ครบ ภาพชัดเจน และแสงสม่ำเสมอ รูปละไม่เกิน 5MB รองรับ JPG, JPEG และ PNG",
  "next": "ถัดไป",
  "previous": "ก่อนหน้า",
  "identityVerification": "ยืนยันตัวตน",
  "confirmLeave": "ยืนยันการออก",
  "leaveWarning": "คุณแน่ใจหรือไม่ว่าต้องการออก ข้อมูลที่กรอกไว้จะหายไป",
  "cancel": "ยกเลิก",
  "recordingInstructions": "ถือเอกสารยืนยันตัวตนไว้กับตัวคุณในวิดีโอ และพูดตัวเลขยืนยัน หลังจากพูดตัวเลขแล้ว ให้หันเอกสารเข้ากล้องเป็นเวลา 1–3 วินาทีโดยหลีกเลี่ยงแสงสะท้อน ข้อมูลในเอกสารและวิดีโอต้องเห็นได้ชัดเจน มิฉะนั้นการตรวจสอบอาจไม่ผ่าน",
  "cameraPermissionRequired": "ยังไม่ได้เปิดสิทธิ์กล้องหรือไมโครโฟน คุณเปลี่ยนได้ในการตั้งค่า",
  "processingVideo": "กำลังประมวลผลวิดีโอ…",
  "recordAgain": "บันทึกอีกครั้ง",
  "submitForReview": "ส่งเพื่อตรวจสอบ",
  "unableToRecordVideo": "ไม่สามารถบันทึกวิดีโอได้",
  "unableToPlayVideo": "ไม่สามารถเล่นวิดีโอได้",
  "dataLoadFailed": "โหลดข้อมูลไม่สำเร็จ",
  "resetFailed": "รีเซ็ตไม่สำเร็จ",
  "reviewPending": "กำลังตรวจสอบ",
  "reviewPendingDescription": "อัปโหลดสำเร็จแล้ว เราจะตรวจสอบข้อมูลที่ส่งโดยเร็วที่สุด",
  "reviewApproved": "ผ่านการตรวจสอบ",
  "reviewApprovedDescription": "ยินดีด้วย การยืนยันตัวตนของคุณผ่านการตรวจสอบแล้ว",
  "reviewRejected": "ไม่ผ่านการตรวจสอบ",
  "reviewRejectedDescription": "ขออภัย การตรวจสอบของคุณไม่ผ่านเนื่องจาก:",
  "fillInAgain": "กรอกใหม่",
  "uploadFailed": "อัปโหลดไม่สำเร็จ โปรดลองอีกครั้งภายหลัง",
  "identityAlreadyVerified": "หมายเลขบัตรประจำตัวนี้ได้รับการยืนยันแล้ว",
  "verificationFailed": "การยืนยันตัวตนไม่สำเร็จ",
  "uploadIdentityPhotos": "โปรดอัปโหลดรูปด้านหน้าและด้านหลังของบัตรประจำตัว",
  "invalidImageFormat": "รูปแบบรูปภาพไม่ถูกต้อง",
  "imageTooLarge": "ขนาดรูปภาพเกินขีดจำกัด 5MB",
  "unableToReadImage": "ไม่สามารถอ่านรูปภาพที่เลือกได้",
  "prepareVideo": "เตรียมบันทึกวิดีโอสำหรับการยืนยันตัวตน โปรดตรวจสอบให้แน่ใจว่าเครือข่ายเสถียร วิดีโอต้องมีความยาวไม่เกิน 15 วินาที และแนะนำให้ใช้ Wi‑Fi เพื่อป้องกันการอัปโหลดล้มเหลว",
  "startRecording": "เริ่มบันทึก",
  "uploading": "กำลังอัปโหลด โปรดรอสักครู่",
  "retryUpload": "ลองอัปโหลดอีกครั้ง"
}
